import React from 'react';
import SVGClose from '../../svg/Close';

class ActiveFilters extends React.Component {
  render() {
    const { activeFilters } = this.props;

    return (
      <div className="filters">
        {activeFilters.map(filter => this.renderFilter(filter))}
      </div>
    );
  }

  renderFilter(filter) {
    const { toggleFilter } = this.props;
    return (
      <div
        key={filter.key}
        className="filter__tag"
        onClick={() => toggleFilter(filter)}
      >
        {filter.optionLabel}
        <span className="filter__tag-icon">
          <SVGClose />
        </span>
      </div>
    );
  }
}

export default ActiveFilters;



// WEBPACK FOOTER //
// ./src/components/shared/ActiveFilters.js